import { WarehouseProductsModule } from '@/shared';

export default WarehouseProductsModule;
